import { Chart as ChartJS, LineElement, Tooltip, Legend, CategoryScale, LinearScale, PointElement } from 'chart.js'
import { Line } from 'react-chartjs-2';
import { GraphContainer } from "./GraphContainer";
import { Loading } from '../../common';

ChartJS.register(
  Tooltip, Legend, CategoryScale, LinearScale, PointElement, LineElement,
);
const options = {
  responsive: true,
  plugins: {
    legend: {
      display: false,
    },
    layout: {
      padding: {
        right: 20, 
      },
    },
    interaction: {
      mode: "nearest", 
      intersect: false, 
    },
    datalabels: {
      display: false, 
    },
  },
};
const chartHeight = 230;

export const LineChart = (props) => {

  const data = {
    labels: props.labels,
    datasets: props.datasets
  }
  return (
    <GraphContainer
      title={props.title}
      legendType="square"
      legends={props.legends}
      {...props}
    >
      {props.isLoading
        ? <div className='flexRow justifyContentCenter alignItemsCenter' style={{height: `${chartHeight}px`}}><Loading/></div>
        : <div style={{ height: `${chartHeight}px`, width: '100%', position: 'relative' }}>
            <Line options={{ ...options, responsive: true, maintainAspectRatio: false }} datasetIdKey={props.key} data={data} />
          </div>
      }
    </GraphContainer>
  );
}